<template>
  <div>
    <!-- Loading State -->
    <LoadingState
      v-if="loading && !billingRecords.length"
      type="card"
      :loading="true"
      message="Loading billing records..."
      sub-message="Please wait while we fetch your billing history"
    />

    <!-- Error State -->
    <ErrorState
      v-else-if="error && !billingRecords.length"
      type="card"
      title="Failed to Load Billing Records"
      :message="error"
      details="Please check your connection and try again"
      error-type="network"
      :show-retry="true"
      :show-support="true"
      @retry="refreshData"
      @support="contactSupport"
    />

    <!-- Empty State -->
    <EmptyState
      v-else-if="!loading && !billingRecords.length"
      title="No Billing Records Found"
      message="You haven't created any billing records yet."
      description="Start by creating your first electricity bill to see it appear here."
      icon="mdi-receipt-text-outline"
      icon-color="primary"
      primary-action-text="Create First Bill"
      primary-action-icon="mdi-plus"
      :show-create="true"
      :show-refresh="true"
      @primary-action="createNewBill"
      @refresh="refreshData"
    />

    <!-- Billing List or Detail View -->
    <router-view
      v-else
      @show-message="showMessage"
    />

    <!-- Global Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.message }}
      <template #action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadingState from '../components/common/LoadingState.vue';
import ErrorState from '../components/common/ErrorState.vue';
import EmptyState from '../components/common/EmptyState.vue';

export default {
  name: 'BillingHistory',

  components: {
    LoadingState,
    ErrorState,
    EmptyState,
  },

  data() {
    return {
      snackbar: {
        show: false,
        message: '',
        color: 'success',
        timeout: 5000,
      },
    };
  },

  computed: {
    ...mapGetters('billing', ['allBillingRecords', 'loading', 'error']),

    billingRecords() {
      return this.allBillingRecords || [];
    },
  },

  async created() {
    await this.refreshData();
  },

  methods: {
    ...mapActions('billing', ['fetchBillingRecords']),

    async refreshData() {
      try {
        await this.fetchBillingRecords();
      } catch (error) {
        console.error('Error refreshing billing records:', error);
        this.showMessage({
          type: 'error',
          message: 'Failed to refresh billing records',
        });
      }
    },

    createNewBill() {
      this.$router.push('/billing-entry');
    },

    contactSupport() {
      this.showMessage({
        type: 'info',
        message: 'Support contact information: support@shopworx.com',
      });
    },

    getSnackbarColor(type) {
      const colorByType = {
        error: 'error',
        warning: 'warning',
        info: 'info',
      };

      return colorByType[type] || 'success';
    },

    showMessage({ type, message }) {
      this.snackbar = {
        show: true,
        message,
        color: this.getSnackbarColor(type),
        timeout: type === 'error' ? 8000 : 5000,
      };
    },
  },
};
</script>
